'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import UserStore from '@stores/UserStore';

import './NoResults.scss';

export default class NoResults extends Component {

    static contextTypes = {
        showCreateCustom: PropTypes.func,
        createCustomButtonCopy: PropTypes.node,
        showUpgradeForm: PropTypes.func,
    };

    static propTypes = {
        noResultsCopy: PropTypes.node,
        hideCreateCustom: PropTypes.bool,
        overrideCreateCustomButtonCopy: PropTypes.node
    };

    static defaultProps = {
        noResultsCopy: 'No results found',
    };

    upgradeMembership = () => {
        const { showUpgradeForm } = this.context;
        showUpgradeForm({ feature: 'create_content' });
    };

    render() {
        const { params, noResultsCopy, hideCreateCustom, overrideCreateCustomButtonCopy } = this.props;
        const { showCreateCustom, createCustomButtonCopy } = this.context;
        
        const user = UserStore.getUser();
        const { capabilities = {} } = user || {};
        const { create_content = false } = capabilities;

        return (
            <div className="global-search-no-results">
                <h2>{noResultsCopy}</h2>
                <i className="icon-silverware1" onClick={create_content ? () => showCreateCustom({defaultCustomTitle: params.terms}) : this.upgradeMembership} />
                {showCreateCustom && !hideCreateCustom ?
                    <footer>
                        {create_content 
                            ? <button className="create-custom-meal-btn" onClick={() => showCreateCustom({defaultCustomTitle: params.terms})}>
                                {overrideCreateCustomButtonCopy || createCustomButtonCopy || 'create custom food'}
                            </button>
                            : <button className="create-custom-meal-btn" onClick={this.upgradeMembership}>
                                {overrideCreateCustomButtonCopy || createCustomButtonCopy || 'create custom food'} <i className="icon-lock" />
                            </button>
                        }
                    </footer>
                : null}
            </div>
        );
    }
}
